export const teamMembers = [
  {
    name: '老炮',
    role: '创始人 & 首席编辑',
    bio: '十五年户外与装备玩家，曾穿越川藏线、徒步尼泊尔ABC。对一切硬核装备有着近乎偏执的挑剔，坚信好的装备值得被更多人知道。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20mature%20Chinese%20man%20in%20his%2040s%20with%20short%20hair%20and%20salt%20pepper%20beard%2C%20wearing%20dark%20canvas%20jacket%2C%20confident%20rugged%20expression%2C%20outdoor%20lighting%2C%20dark%20background&width=200&height=200&seq=team-laopao&orientation=squarish',
  },
  {
    name: '丹宁老张',
    role: '穿搭主笔',
    bio: '十年丹宁玩家，养过二十多条原牛。对工装、复古、阿美咔叽风格如数家珍，坚信穿搭是男人表达自我的方式。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20stylish%20Chinese%20man%20in%20his%2030s%20with%20undercut%20hairstyle%2C%20wearing%20dark%20denim%20shirt%2C%20fashionable%20confident%20expression%2C%20studio%20portrait%20lighting%2C%20dark%20background&width=200&height=200&seq=team-danning&orientation=squarish',
  },
  {
    name: '键盘侠阿凯',
    role: '数码编辑',
    bio: '前硬件工程师，现全职数码评测。对参数敏感，对体验更敏感。用工程师的严谨和玩家的热情，帮你避开数码产品的坑。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20man%20with%20glasses%20in%20his%20late%2020s%2C%20wearing%20black%20hoodie%2C%20intelligent%20focused%20expression%2C%20studio%20portrait%20with%20clean%20lighting%2C%20dark%20background&width=200&height=200&seq=team-akai&orientation=squarish',
  },
  {
    name: '野人阿飞',
    role: '户外探险编辑',
    bio: '资深户外领队，登过四姑娘山、穿越过腾格里沙漠。相信大自然是最好的老师，而好的装备是安全回家的保障。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20tanned%20outdoorsy%20Chinese%20man%20in%20his%2030s%2C%20wearing%20technical%20outdoor%20jacket%2C%20adventurous%20smile%2C%20natural%20mountain%20lighting%2C%20scenic%20background&width=200&height=200&seq=team-afei&orientation=squarish',
  },
];

export const testimonials = [
  {
    name: '陈先生',
    role: '资深户外爱好者',
    content: '照着男子汉宝藏的装备清单买了一套露营装备，第一次露营体验就非常棒。推荐的东西确实都经过实战检验，不是随便凑的。',
    rating: 5,
  },
  {
    name: '李工',
    role: '机械工程师',
    content: 'EDC指南那篇文章我反复看了三遍，每件推荐的单品都去研究了，最后入手的折刀和手电用了一年多，品质非常靠谱。',
    rating: 5,
  },
  {
    name: '王老板',
    role: '创业者',
    content: '腕表推荐那篇帮我选到了人生第一块机械表，美度领航者，戴了半年越看越喜欢。感谢专业且真诚的推荐！',
    rating: 5,
  },
  {
    name: '小赵',
    role: '程序员',
    content: '键盘横评写得太详细了，参数对比一目了然。最后选了Keychron Q1，打字手感完美，代码效率都提升了。',
    rating: 4,
  },
  {
    name: '大刘',
    role: '健身教练',
    content: '家庭健身房那篇文章帮我用不到3000块就搭了一个高效训练区。现在每天在家练，比去健身房还规律。',
    rating: 5,
  },
  {
    name: '周律师',
    role: '律师',
    content: '皮靴养护指南太实用了！照着方法保养的Red Wing穿了三年状态还很好，感谢专业分享。',
    rating: 5,
  },
];